<template>
  <el-container class="main-content">
    <el-aside class="left-panel" width="340px">
      <resumeHelperCard></resumeHelperCard>
      <proResumeCard></proResumeCard>
    </el-aside>
    <el-main class="right-panel">
      <resumeInfo :resumeId="resumeId"></resumeInfo>
    </el-main>
  </el-container>
</template>

<script>
  import resumeInfo from '~/components/ResumeInfo';
  import resumeHelperCard from '~/components/resumeHelperCard';
  import proResumeCard from '~/components/ProResumeCard';
  export default {
    components: {
      resumeInfo,
      resumeHelperCard,
      proResumeCard
    },
    data() {
      return {
        resumeId: parseInt(this.$route.query.id),        
      };
    },
    created() {
      if (!this.resumeId) {
        this.$message.error('未找到简历');
      }
    },
    methods: {      
    }
  };
</script>

<style scoped>
</style>